import * as types from '@/store/mutationTypes'

const state = {
  curLoadingInfo: {
    status: false,
    text: 'loading ...'
  },
  curRefeshState: false,
  curMessage: {
    message: '',
    type: 'success'
  }
}

const getters = {
}

const mutations = {
  [types.REFRESH_BASE_INFO] (state, curState) {
    state.curRefeshState = curState
  },
  [types.SET_CUR_MSG] (state, msg) {
    state.curMessage = msg
  },
  [types.SET_LOADING_INFO] (state, info) {
    state.curLoadingInfo = info
  }
}

const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/global.js